import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tooltipArrowFn = /* @__PURE__ */ createRecipe('tooltip__arrow', {}, [])

const tooltipArrowVariantMap = {}

const tooltipArrowVariantKeys = Object.keys(tooltipArrowVariantMap)

export const tooltipArrow = /* @__PURE__ */ Object.assign(memo(tooltipArrowFn.recipeFn), {
  __recipe__: true,
  __name__: 'tooltipArrow',
  __getCompoundVariantCss__: tooltipArrowFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: tooltipArrowVariantKeys,
  variantMap: tooltipArrowVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tooltipArrowVariantKeys)
  },
  getVariantProps: tooltipArrowFn.getVariantProps,
})